module.exports = __webpack_public_path__ + "static/img/5.245b1d49.png";